module.exports = ".email-history-spinner {\r\n    height: 130px; /* Prevents the scrollbar from appearing on the dialog since the spinner height changes during animation */\r\n}\r\n\r\n.email-content {\r\n    font-size: 14px;\r\n}\r\n\r\n.label {\r\n    font-weight: 600;\r\n    margin-right: 5px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/enquiry/email-history-dialog/email-history-dialog.component.css
// module id = 648
// module chunks = 1